import { Box, styled, Typography } from "@mui/material";

export const CustomLinkContainer = styled(Box)(() => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginTop: "16px",
}));

export const FieldContainer = styled(Box)(() => ({
  display: "flex",
  gap: 10,
  "@media (max-width: 700px)": {
    display: "block",
  },
}));

export const ModalLink = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  textDecoration: 'underline',
  cursor: 'pointer'
}))